import React from "react";
import { CharacterSheet } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const OutrosCampos: React.FC<Props> = ({ character, onChange }) => {
  return (
    <div className="section">
      <h2>Outros Campos</h2>
      
      <div className="form-grid">
        <div className="form-group">
          <label>Face Atual</label>
          <input
            type="number"
            value={character.faceHumanidade.faceAtual}
            onChange={(e) =>
              onChange({
                ...character,
                faceHumanidade: {
                  ...character.faceHumanidade,
                  faceAtual: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Humanidade (%)</label>
          <input
            type="number"
            value={character.faceHumanidade.humanidade}
            onChange={(e) =>
              onChange({
                ...character,
                faceHumanidade: {
                  ...character.faceHumanidade,
                  humanidade: parseInt(e.target.value) || 100,
                },
              })
            }
            min="0"
            max="100"
          />
        </div>
        <div className="form-group">
          <label>Efeitos (Face/Humanidade)</label>
          <input
            type="text"
            value={character.faceHumanidade.efeitos}
            onChange={(e) =>
              onChange({
                ...character,
                faceHumanidade: {
                  ...character.faceHumanidade,
                  efeitos: e.target.value,
                },
              })
            }
            placeholder="Efeitos"
          />
        </div>
        <div className="form-group">
          <label>Slots de Identidades</label>
          <input
            type="number"
            value={character.slotsIdentidades}
            onChange={(e) =>
              onChange({
                ...character,
                slotsIdentidades: parseInt(e.target.value) || 0,
              })
            }
            min="0"
          />
        </div>
        <div className="form-group">
          <label>XP Atual</label>
          <input
            type="number"
            value={character.experiencia.xpAtual}
            onChange={(e) =>
              onChange({
                ...character,
                experiencia: {
                  ...character.experiencia,
                  xpAtual: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
        </div>
        <div className="form-group">
          <label>XP Total Acumulado</label>
          <input
            type="number"
            value={character.experiencia.xpTotalAcumulado}
            onChange={(e) =>
              onChange({
                ...character,
                experiencia: {
                  ...character.experiencia,
                  xpTotalAcumulado: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Pontos Disponíveis</label>
          <input
            type="number"
            value={character.experiencia.pontosDisponiveis}
            onChange={(e) =>
              onChange({
                ...character,
                experiencia: {
                  ...character.experiencia,
                  pontosDisponiveis: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
        </div>
      </div>

      <div className="form-group">
        <label>Notas e Observações</label>
        <textarea
          value={character.notas}
          onChange={(e) => onChange({ ...character, notas: e.target.value })}
          rows={6}
          placeholder="Anotações sobre o personagem..."
        />
      </div>
    </div>
  );
};
